import { ColorConstant } from '../constants';
import { RequestAction } from '.';

export const createColor = data =>
  RequestAction.request(ColorConstant.CREATE_COLOR, {
    data,
    method: 'post',
    url: `/api/color`,
  });

export const deleteColor = id =>
  RequestAction.request(ColorConstant.DELETE_COLOR, {
    method: 'delete',
    url: `/api/color/${id}`,
  });

export const editColor = (id, data) =>
  RequestAction.request(ColorConstant.EDIT_COLOR, {
    data,
    method: 'put',
    url: `/api/color/${id}`,
  });

export const getColor = id =>
  RequestAction.request(ColorConstant.GET_COLOR, { url: `/api/color/${id}` });

export const getColors = params =>
  RequestAction.request(ColorConstant.GET_COLORS, {
    params,
    url: '/api/color',
  }, false);

export const setColor = payload => ({
  payload,
  type: ColorConstant.SET_COLOR,
});

export const setColors = payload => ({
  payload,
  type: ColorConstant.SET_COLORS,
});
